<!--
 * @Descripttion: 应用项
 * @Author: liaoyijun
 * @Date: 2021-08-19 16:29:50
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-10-20 10:25:06
-->

<template>
    <div class="app-container">
        <!-- 图片 -->
        <div class="title-icon-box">
            <div class="icon-box">
                <div class="icon-item">
                    <i :class="'nav-icon iconnewhope ' + item.icon" :style="{ color: item.color }"></i>
                </div>
            </div>
            <!-- 标题 -->
            <div class="icon-title">
                <span>
                    {{ item.name }}
                </span>
                <div class="comment">
                    {{ item.comment }}
                </div>
            </div>
        </div>

        <!-- button -->
        <div class="button-container">
            <el-button
                v-if="item.showStatus === '3' && !item.isCommonUse"
                size="small"
                :loading="delLoading"
                @click="handelRemove(item)"
            >
                移除
            </el-button>
            <el-button
                v-if="item.showStatus === '2' && !item.isCommonUse"
                size="small"
                :loading="addLoading"
                type="primary"
                @click="handelAdd(item)"
            >
                添加
            </el-button>
            <el-button v-if="item.showStatus === '1'" size="small" type="info" disabled>无权限</el-button>
        </div>
    </div>
</template>

<script>
import { addAppItem, removeAppItem } from "@/api";
import { customTrackEvent } from "@/libs/mUtils";
export default {
    name: "AddAppList",
    components: {},
    props: {
        status: {
            type: String,
            default: "",
        },
        item: {
            type: Object,
            default: () => [],
        },

        appType: {
            type: String,
            default: "",
        },
    },

    data() {
        return {
            addLoading: false,
            delLoading: false,
        };
    },

    mounted() {
        const el = document.querySelectorAll(".app-container");
        el[el.length - 1].style.border = "none";
    },

    methods: {
        //移除
        handelRemove(item) {
            this.delLoading = true;
            customTrackEvent(() => {
                this.$ba.trackEvent(`移除${item.name}应用`, "click", this.pointLabel);
            });

            let RemoveInfo = {
                appType: this.appType,
                id: item.id,
            };
            removeAppItem(RemoveInfo).then(() => {
                this.$emit("refresh", false);
                this.$message.closeAll();
                setTimeout(() => {
                    this.delLoading = false;
                    this.$message("应用移除成功！");
                }, 600);
            });
        },
        //添加
        handelAdd(item) {
            this.addLoading = true;
            customTrackEvent(() => {
                this.$ba.trackEvent(`添加${item.name}应用`, "click", this.pointLabel);
            });
            let addInfo = {
                appType: this.appType,
                id: item.id,
            };
            addAppItem(addInfo).then(() => {
                this.$emit("refresh", false);
                this.$message.closeAll();
                setTimeout(() => {
                    this.addLoading = false;
                    this.$message("应用添加成功！");
                }, 600);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 23px;
    margin-right: 20px;
    padding-bottom: 12px;
    &:not(:last-child) {
        border-bottom: 1px solid #e1e2e3;
    }

    &:not(:first-child) {
        margin-top: 12px;
    }

    .title-icon-box {
        display: flex;
        .icon-box {
            display: flex;
            height: 52px;
            width: 52px;
            justify-content: center;
            align-items: center;
            border-radius: 4px;
            background-color: #fff;
            .icon-item {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 32px;
                width: 28px;

                .nav-icon {
                    width: 54px;
                    height: 54px;
                    text-align: center;
                    line-height: 54px;
                    font-size: 30px !important;
                }

                .iconnewhope {
                    font-size: 34px;
                }
            }
        }

        .icon-title {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 500px;
            height: 52px;
            margin-left: 15px;
            span {
                display: inline-block;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #000000;
                padding-bottom: 10px;
            }
            .comment {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
            }
        }
    }

    .button-container {
        /deep/ .el-button--small {
            padding-left: 0px;
            padding-right: 0px;
            width: 75px;
        }
    }
}
</style>
